import instance from '@/plugins/axios'
import type { ResponseResult } from '@/core/models/api-responses'
import { LocationDTO } from '../models/location';

async function getAll(queryString = ''): Promise<ResponseResult<LocationDTO[]>> {
    const url = queryString ? `/Locations?${queryString}` : '/Locations'
    const res = await instance.get<ResponseResult<LocationDTO[]>>(url)
    return res.data
}

export default {
    getAll,
}
